export enum PREVIEW_AUDIO_END_PROMPT_ACCESS_TYPE {
    authLocked = 'authLocked',
    payLocked = 'payLocked',
}

export default PREVIEW_AUDIO_END_PROMPT_ACCESS_TYPE;
